import React, { useState } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { action_fetch_staging_info } from '../../../../../store/actions/pages/policy'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { useQuery } from '../../../../hooks/common'
import { fetchStagingPrice } from '../../../../../api'
import { useEffect } from 'react'
import { unitPrice } from '../../../../../utils/product'

const StagingInfo = props => {
    useStyles(classes)
    const pagePolicy = useSelector(state => state.pagePolicy);
    const { stagingInfo } = pagePolicy
    const global = useSelector(state => state.global)
    const { country, currency } = global

    const query = useQuery()

    const [stagingList, setStagingList] = useState([])

    useEffect(() => {
        getPrice()
    },[])

    const getPrice = () => {
        fetchStagingPrice({country:country, totalAmount: query?.total, currency: currency}).then(res => {
            if(res?.code == 200 && res?.result){
                setStagingList(res.result)
            }
        })
    }

    const messageData = useMemo(() =>{
        if(stagingInfo?.[country]){
            let message = stagingInfo?.[country];
            return message; 
        }else{
            return null;
        }
    },[stagingInfo, country]);

    const getTotal = (num) => {
        return unitPrice({...num, amount:  Math.round((Number(query?.total || 0) + Number(num?.amount || 0)) * 100) /100})
    }
  
    return <React.Fragment>
        <div className={classes.stagTableBox}>
            <div className={classes.stagTitle}><FormattedMessage id="installment_forms"/></div>
            <table className={classes.stagTable}>
                {
                    stagingList?.map((item, index) => {
                        const isFree = item?.commission?.amount == 0
                        return <tr>
                            <td>{item?.number} x</td>
                            <td>{unitPrice(item?.stagePrice)}</td>
                            <td>{isFree ? <FormattedMessage id="interest_free"/>: <FormattedMessage id="staging_rates"/>}</td>
                            <td><FormattedMessage id="total"/>{' '+ (getTotal(item?.commission))}</td>
                        </tr>
                    })
                }
            </table>
            <div className={classes.stagIconTitle}><FormattedMessage id="accpect"/></div>
            <div className={classes.stagIcon}>
                <img src={messageData?.icon} alt="" />
            </div>
        </div>
        
    </React.Fragment>
}

StagingInfo.fetchData = async (store, params, search, headers) => {
    await store.dispatch(action_fetch_staging_info(headers))
}

export default StagingInfo
